export const FEATURES_FLAGS = [
  'replaceMaterialsInAssortment',
  'replaceMaterialsInLaunches',
  'permissionOverrides',
  'viewPnlGraphs',
  'clrEmailNotifications',
  'clrAutoPrepareDigest',
  'massClr',
  'clrInbox',
  'initiatives',
  /**
   * Blocked orders: treat a DCD case that vanished from `fuze_cache` as SAP having processed the
   * decision. Off until BAT confirms removal is what SAP does, since a cache rebuild would otherwise
   * confirm every open decision at once.
   */
  'blockedOrderSapRemovalConfirms',
] as const

export type FeatureFlag = (typeof FEATURES_FLAGS)[number]
export type FeatureFlags = Record<FeatureFlag, boolean>

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = FEATURES_FLAGS.reduce((acc, flag) => {
  acc[flag] = false
  return acc
}, {} as FeatureFlags)
